import { useTranslation } from 'react-i18next';
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import AccomodationIcon from "assets/svgs/accomodationIconBlack.svg";
import StandByIcon from "assets/svgs/standbyIconBlack.svg";
import LeftHandedIcon from "assets/svgs/leftHandedIconBlack.svg";
import OnlineIcon from "assets/svgs/onlineIconBlack.svg";
import MismatchIcon from "assets/svgs/mismatchIcon.svg";
import { AlertNotice, Spinner } from "shared/components";

const RosterList = ({
  examineeList,
  selectAll,
  allSelected,
  selectExaminee,
  showStudent,
  studentsLoading,
  assignedStudents,
  testCenterCycle,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(
      (el) => bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }, [examineeList]);

  if (studentsLoading) {
    return <Spinner />;
  }

  if (assignedStudents.length === 0 && !studentsLoading) {
    return (
      <div>
        <AlertNotice message={t("roomRoster.noExamineeAssigned")} />
      </div>
    );
  }

  return (
    <div className="roster-list">
      <div className="roster-list-header roster-row">
        <div className="roster-checkbox">
          <input
            type="checkbox"
            name={`select-all`}
            id="selectAll"
            value="selectAll"
            onChange={selectAll}
            checked={allSelected}
          />
          <label htmlFor="selectAll"></label>
        </div>
        <div>{t("roomRoster.selectAll")}</div>
        {testCenterCycle?.cycle?.seatingChartRequiredFlag ? (
          <div>{t("roomRoster.seat")}</div>
        ) : (
          <div style={{ visibility: "hidden" }}>&nbsp;</div>
        )}
        <div>{t("roomRoster.examType")}</div>
        <div>{t("roomRoster.timing")}</div>
      </div>
      {examineeList.map((item) => (
        <div className="roster-row" key={item.id}>
          <div className="roster-checkbox">
            <input
              type="checkbox"
              name={`select-all`}
              id={item.id}
              value={item.id}
              onChange={selectExaminee}
              checked={item.checked}
            />
            <label htmlFor={item.id}></label>
          </div>
          <div className="student-info">
            <div
              className="student-name text-ellipsis"
              onClick={() => showStudent(item)}
            >{`${item.lastName}, ${item.firstName} ${
              item.middleName ? item.middleName : ""
            }`}</div>
            <div>
              {item.standByFlag && (
                <div
                  tabIndex="0"
                  className="icons d-inline-block"
                  data-bs-toggle="popover"
                  data-bs-placement="top"
                  data-bs-trigger="hover"
                  data-bs-boundary="window"
                  data-bs-content={t("rosters.tooltipStandBy")}
                >
                  <StandByIcon />
                </div>
              )}
              {item.onlineFlag && (
                <div
                  tabIndex="0"
                  className="icons d-inline-block"
                  data-bs-toggle="popover"
                  data-bs-placement="top"
                  data-bs-trigger="hover"
                  data-bs-boundary="window"
                  data-bs-content={t("rosters.tooltipOnline")}
                >
                  <OnlineIcon />
                </div>
              )}
              {item.accomRosterFlag && (
                <div
                  tabIndex="0"
                  className="icons d-inline-block"
                  data-bs-toggle="popover"
                  data-bs-placement="top"
                  data-bs-trigger="hover"
                  data-bs-boundary="window"
                  data-bs-content={t("rosters.tooltipAccomodation")}
                >
                  <AccomodationIcon />
                </div>
              )}
              {item.leftHandedFlag && (
                <div
                  tabIndex="0"
                  className="icons d-inline-block"
                  data-bs-toggle="popover"
                  data-bs-placement="top"
                  data-bs-trigger="hover"
                  data-bs-boundary="window"
                  data-bs-content={t("rosters.tooltipLeftHand")}
                >
                  <LeftHandedIcon />
                </div>
              )}
              {(item.timingIncompatibility > 0 ||
                item.roomTypeIncompatibility > 0 ||
                item.singleRoomIncompatibility > 0) && (
                <div
                  tabIndex="0"
                  className="icons d-inline-block warning-icon"
                  data-bs-toggle="popover"
                  data-bs-placement="top"
                  data-bs-trigger="hover"
                  data-bs-boundary="window"
                  data-bs-content={t("rosters.tooltipMismatch")}
                >
                  <MismatchIcon />
                </div>
              )}
            </div>
          </div>
          {testCenterCycle?.cycle?.seatingChartRequiredFlag ? (
            <div>
              {typeof item.seatRow === "number" &&
              typeof item.seatCol === "number"
                ? `${String.fromCodePoint(item.seatRow + 65)} - ${
                    item.seatCol + 1
                  }`
                : `-`}
            </div>
          ) : (
            <div style={{ visibility: "hidden" }}>&nbsp;</div>
          )}
          <div>{item.regType && item.regType}</div>
          <div>{item.timing && item.timing}</div>
        </div>
      ))}
    </div>
  );
};

RosterList.propTypes = {
  examineeList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      lastName: PropTypes.string,
      firstName: PropTypes.string,
      middleName: PropTypes.string,
      standByFlag: PropTypes.bool,
      onlineFlag: PropTypes.bool,
      accomRosterFlag: PropTypes.bool,
      leftHandedFlag: PropTypes.bool,
      timingIncompatibility: PropTypes.number,
      roomTypeIncompatibility: PropTypes.number,
      singleRoomIncompatibility: PropTypes.number,
      seatRow: PropTypes.number,
      seatCol: PropTypes.number,
      regType: PropTypes.string,
      timing: PropTypes.string,
      checked: PropTypes.bool,
    })
  ).isRequired,
  selectAll: PropTypes.func.isRequired,
  allSelected: PropTypes.bool.isRequired,
  selectExaminee: PropTypes.func.isRequired,
  showStudent: PropTypes.func.isRequired,
  studentsLoading: PropTypes.bool,
  assignedStudents: PropTypes.array.isRequired,
  testCenterCycle: PropTypes.shape({
    cycle: PropTypes.shape({
      seatingChartRequiredFlag: PropTypes.bool,
    }),
  }),
};

export default RosterList;
